<template>
    <div :class="{'pp-content':1, 'pp-content--fullscreen': empty }">
        <div :class="{'pp-search':1, 'pp-search--zerostate': empty }">
            <div class="pp-search-bar">
                <input v-model="term" ref="mobileSearch" @keydown="onKeyDown" @focus="onFocus" @blur="onBlur" class="pp-search-bar__input" type="search" placeholder="Search">
            </div>

            <div v-if="empty && !hideEmptystate" class="pp-search__icon">
                <img src="/assets/images/search_icon.png">
            </div>
            <div v-if="empty && term && !hideEmptystate" class="pp-search__content">
                We can't find anything for those search terms.
            </div>
            <div v-if="empty && !term && !hideEmptystate" class="pp-search__content">
                Search for albums or tracks by title, composer, ensemble, artist, or code
            </div>

            <div v-if="!empty" class="pp-search__results">
                <div class="pp-section">
                    <div class="pp-section__header">
                        Ensemble search results for '{{ term }}'
                    </div>
                    <artist-grid v-if="ensembles.length > 0"
                                 link-to="/browse/ensembles/{id}"
                                 :items="ensembles"
                                 @paginate="loadMore"
                                 :reached-end="reachedEnd"
                                 :paginating="paginating"
                                 :can-paginate="true">
                    </artist-grid>
                </div>
            </div>
        </div>
    </div>
</template>



<script>
import { api } from '../API.js';
import EventBus from '../EventBus.js';
import AlbumGrid from '../components/AlbumGrid.vue';
import ArtistGrid from '../components/ArtistGrid.vue';
import TrackList from '../components/TrackList.vue';

export default {
    name: 'search-ensembles',
    components: {
        AlbumGrid,
        ArtistGrid,
        TrackList
    },
    data() {
        return {
            term: '',
            ensembles: [],

            page: 1,
            reachedEnd: false,
            paginating: false,
            loading: true,

            hideEmptystate: false,
        };
    },
    computed: {
        empty() {
            return this.ensembles.length == 0;
        }
    },
    watch: {
        '$route': 'fetchData'
    },
    mounted() {
        this.fetchData();
    },
    methods: {
        onKeyDown(e) {
            if (e.which == 13) {
                this.search();
            }
        },

        onFocus() {
            this.hideEmptystate = true;
            EventBus.emit('mobile.footers', {
                visible: false
            });
        },

        onBlur() {
            this.hideEmptystate = false;
            EventBus.emit('mobile.footers', {
                visible: true
            });
        },

        search() {
            var term = this.term.trim();
            if (!term) {
                this.$router.push({
                    path: '/search',
                    query: {
                        q: ''
                    }
                });
                return;
            }

            this.$router.push({
                path: '/search',
                query: {
                    q: term
                }
            });

            this.$refs.mobileSearch.blur();
        },


        fetchData() {
            this.loading = true;

            console.log('fetchData');
            this.page = 1;
            this.paginating = false;
            this.load();
        },

        loadMore() {
            if (this.paginating) { return; }

            this.page++;
            this.paginating = true;
            this.load(true);
        },

        load() {
            this.term = this.$route.query.q;

            if (!this.term) {
                this.ensembles = [];
                return;
            }

            api.get('/search', {}, {
                term: this.term,
                limit: 100,
                page: this.page,
                type: 'ensembles'
            }, (data) => {
                if (this.paginating) {
                    if (data.results.ensembles.length == 0) {
                        this.reachedEnd = true;
                    } else {
                        for (let item of data.results.ensembles) {
                            this.ensembles.push(item);
                        }
                    }
                } else {
                    this.ensembles = data.results.ensembles;
                    this.loading = false;
                }

                setTimeout(() => {
                    this.paginating = false;
                }, 250);
            }, () => {
                console.log('Error!');
            })
        }

    }
}
</script>



// WEBPACK FOOTER //
// SearchEnsembles.vue?b27063d4